/* istanbul ignore file */
import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { difference, get, isEmpty, isNil, uniq, without } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { Container } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/styled-components';
import {
  ICivilJudgement,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import {
  getBeneficiaries,
  useBeneficiaries,
  useDahirAmountByVictimKey,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/hooks';
import CivilJudgementRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap';
import CorrectionalJudgementManagerRecap from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/CorrectionalJudgementManagerRecap';

import SecondaryButton from 'components/Buttons/SecondaryButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import {
  CONTESTATION,
  CONTESTATION_AGAINST,
  EMPTY_JUDGEMENT_ON_MERITS_DOC,
  PROCEDURE_STATUSES,
  VEHICULE_EXPERTISE_FIELDS,
  VICTIM_EXPERTISE_FIELDS,
} from 'containers/data-structure';
import { formatNextOfKins } from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';
import { Config, Listings } from 'containers/AppContainer/typings';
import {
  getJudgementOnMeritsVictims,
  getVehiculeIds,
  getVictimIds,
  getVictimKeys,
  isContested,
  hasOtherReason,
  getInjuredVictims,
  formatExpertisesWithExpertReport,
  priorityClaimReason,
  filterAccountingCivjs,
  resolveSlectedDeceasedVictims,
  getDeceasedVictims,
  shouldValidateDesceasedVictims,
  disableOnValidationButton,
  validateCivilJudgementsOnRecap,
  filterExpertises,
  disableSharedResponsibility,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import JudgementOnMeritsInfo from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementOnMeritsInfo';
import AdditionalInfoJudgementOnMerit from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/AdditionalInfoJudgementOnMerit';
import { ISuedPartyType } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import { StyledSecondaryButton } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/styled-components';
import deleteIcon from 'images/delete-icon.svg';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import DeceasedVictim from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/deceasedVictim';
import JudgementOnMeritsForm from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/JudgementOnMeritsForm';
import AdditionalInfoJudgementOnMeritForm from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/AdditionalInfoJudgementOnMeritsForm';
import {
  LEGAL_PROCEEDINGS_STEPS,
  PROCEDURE_STEPS_INDEX,
  PROCEDURE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/constants';
import {
  formatAccExpertises,
  formatMechanicalExpertises,
  formatMedExpertises,
  getCivilJudgement,
  getDeceasedVictim,
  addNewCivjJudgement,
  addAccountingExpertiseAfterMerge,
  getJudgementAddDocument,
  updateVehicleAccountingExpertiseAfterMerge,
  isBeneficiaryNotEmpty,
  getJudgementAddDocumentsWithoutCivjs,
  getAllBeneficiaries,
  mapJudiciaryProcessEvaluations,
  mapCivilDocumentsEvaluations,
  mapReasonWithoutCompensationEvaluations,
  mapSagisEvaluationWithoutExpertise,
  mapSagisEvaluation,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { mergeEvaluationsV2 } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import SahamDrawer from 'components/SahamDrawer';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/styled-components';
import { getVictimFullName } from 'containers/LawyerLegalProceedingsPage/judgementAppeal/CivilJudgement/Expertises/utils';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import {
  isUserActive,
  showValidator,
} from 'containers/common/LegalProceedings/utils';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import RejectionDialog from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/RejectionDialog';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import {
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
  COMPTABLE_EXPERTISE_ID,
  JUDGEMENT_EXPERTISE_TYPES,
  MODE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import AddJomDrawer from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/AddJomDrawer';
import {
  getCivjVictims,
  getDeceasedJomVictims,
  getJomVictims,
  isDeceasedVictimsOnly,
  isPendingApprovalClaim,
} from 'containers/LawyerLegalProceedingsPage/utils';
import { getJudgementAddDocuments } from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/utils';
import { Dialog } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/styled-components';
import { resolveSagisClaim } from 'helpers/utils';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import UpdateStepRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/UpdateStepRecap';
import ValidationDialog from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/ValidationDialog';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { addNewJudgementNonCompensation } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/utils';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { CIVIL_JUDGEMENT_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/constants';
import InjuredVictimsRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/InjuredVictimsRecap';
import { resolveJudgementAddAppeal } from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/utils';
import CivilJudgementForm from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementForm';
import { isExpertReportWithoutDecision } from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';
import { removeWhiteSpaceFromString } from 'services/utils';
import { filterVictim } from 'containers/CourtManagerLegalProceedings/utils';
import { VictimType } from 'typings/globalTypes';

export interface JudgementOnMeritsManagerRecapProps {
  intl: IntlShape;
  listings: Listings;
  uploadDocument: Function;
  setDocumentId: Function;
  documentId: string;
  expertiseReport?: any;
  victims: any;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestGetJudgementOnMerits: Function;
  requestValidateJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  lawyer: string;
  claimId: number;
  claimNumber: string;
  judgementAddDocuments: JudgementADDDocumentType[];
  dahirAmount: [];
  judgementAdd: any;
  policyInfo: { sagis: {} };
  judgementAddClone: any;
  claim: any;
  judiciaryProcessId: number;
  dahirAmountsCorpo: any;
  requestCreateJudgementOnMeritsContestation: any;
  vehicules: any;
  civilProceeding: any;
  isManager: boolean;
  requestAddJudgementOnMeritsSupportDocument: Function;
  isCivilProceeding: boolean;
  setJomLabels?: Function;
  jomAssociatedVictims?: any;
  setJomAssociatedVictims?: Function;
  isMultiple?: boolean;
  jomDeceasedVictims?: any;
  jomVictims?: any;
  jomVehicles?: any;
  setJomAppealLabels?: Function;
  setCurrentInstanceTab?: Function;
  setCurrentActiveTab?: Function;
  setCurrentJom?: Function;
  isAssignedLawyer: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  currentIndexTabManager: any;
  judgementAddAppeal: any;
  requestGetDahirAmount: Function;
  currentInstanceTabIndexManager: any;
  currentGlobalTabManagerIndex: any;
  currentJudiciaryProccessId: any;
  setIsButtonRedirect?: Function;
  setOpenFeeNoteDialog: Function;
  isConsultation: boolean;
  requestMakeDecisionSupportDocument?: Function;
  imagineDocuments: any;
  requestArchiveJudgement?: Function;
  requestGetDocByDocumentumId: Function;
}

export const JudgementOnMeritsManagerRecap: React.FC<JudgementOnMeritsManagerRecapProps> = ({
  listings,
  uploadDocument,
  uploadedDocument,
  resetUploadedDocument,
  documentId,
  setDocumentId,
  requestGetJudgementOnMerits,
  requestValidateJudgementOnMerits,
  lawyer,
  judgementOnMerits,
  claimId,
  claimNumber,
  policyInfo,
  claim,
  expertiseReport,
  victims,
  vehicules,
  civilProceeding,
  setJomLabels,
  setCurrentJom,
  ...props
}): JSX.Element => {
  const isExpertReportNotValidated =
    isExpertReportWithoutDecision(expertiseReport) &&
    get(judgementOnMerits, 'judgementOnMerits.status') === 'PENDING';
  const currentJudiciaryProcess = civilProceeding.find(
    (el: any) => el.id === props.judiciaryProcessId,
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [judgement, setJudgement] = useState({} as any);
  const [civilJudgements, setCivilJudgements] = useState([
    ...getCivilJudgement(judgementOnMerits),
  ]);
  const [archiveReason, setArchiveReason] = useState<string>('');
  const [civjvmRequest, setCivjvmRequest] = useState([
    ...get(judgementOnMerits, 'judgementOnMerits.jom.civjvm', []),
  ]);

  const [sharedResponsability, setSharedResponsability] = useState<string>(
    get(
      getCivilJudgement(judgementOnMerits),
      '[0].responsibilityShare',
      null,
    ) ||
      get(
        judgementOnMerits,
        'judgementOnMerits.jom.civjvm.[0].responsibilityShare',
        null,
      ) ||
      get(
        judgementOnMerits,
        'beneficiaries.[0].beneficiary.victim.responsibilityShare',
        null,
      ),
  );
  const [judgementOnMeritsRequest, setJudgementOnMeritsRequest] = useState({});

  const newCivjvm = Object.values(
    get(judgementOnMeritsRequest, 'civjvm', []),
  ).filter((item: any) => !isEmpty(item));

  const victimsEvaluationsToInclude = [
    ...getJomVictims([get(judgementOnMerits, 'judgementOnMerits', {})]),
    ...getDeceasedJomVictims([judgementOnMerits], props.judgementAddClone),
    ...get(judgementOnMerits, 'judgementOnMerits.jom.civjvm', []).map(
      (el: any) => el.victimId,
    ),
    ...newCivjvm.map((el: any) => el.victimId),
    ...getCivjVictims(get(judgementOnMeritsRequest, 'civjs', [])),
  ];

  const civilVictimsToInclude = [
    ...get(currentJudiciaryProcess, 'victims', []).map((vic: any) => vic.id),
    ...get(props.judgementAddClone, 'civilDocuments', [])
      .map((el: any) => get(el, 'victims', []))
      .flat()
      .map((vic: any) => vic.id),
  ];

  const jomVictimsToInclude = [...get(props, 'jomVictims', [])];

  const civilVehiclesToInclude = [
    ...get(currentJudiciaryProcess, 'vehicules', []).map((v: any) => v.id),
  ];

  const jomVehiclesToInclude = [...get(props, 'jomVehicles', [])];
  const [responsibilityRate, setResponsibilityRate] = useState(
    get(
      judgementOnMerits,
      '[judgementOnMerits][jom][civjs][0][responsibilityShare]',
      null,
    ),
  );
  const [selectedVictims, setSelectedVictims] = useState<any>([]);
  const [deceasedVictim, handleChangeDesceasedVictim] = useState<any>([]);
  const civilJudgementVictims = get(
    judgementOnMerits,
    'judgementOnMerits.jom.civjvm',
    [],
  ).filter((item: any) => !item?.expertiseJudgementAddDocumentId);
  const [judgementOnMeritsInfo, setJudgementOnMeritsInfo] = useState({});

  const [isAppealDialogOpen, setIsAppealDialogOpen] = useState(false);

  const handleValidateAppealDialog = () => {
    if (props.setJomAppealLabels)
      props.setJomAppealLabels([messages.appealOnMeritsLabelTitle]);
    setIsAppealDialogOpen(false);
    if (setCurrentJom) setCurrentJom(judgementOnMerits);
    if (props.setCurrentInstanceTab)
      props.setCurrentInstanceTab(PROCEDURE_STEPS_INDEX['APPEAL']);
    if (props.setCurrentActiveTab)
      props.setCurrentActiveTab(PROCEDURE_STEPS_INDEX['APPEAL']);
  };

  const handleCloseAppealDialog = () => {
    setIsAppealDialogOpen(false);
  };

  const [judgementOnMeritsInfoForm, setJudgementOnMeritsInfoForm] = useState(
    {},
  );
  const [dahirAmountByVictimKey] = useDahirAmountByVictimKey(
    victims
      .filter(
        (item: any) =>
          item.injuryPostKey === INJURY_POST_DECEASED &&
          !isEmpty(item?.victimKey),
      )
      .map((item: any) => item.victimKey),
    props.judgementAddDocuments,
    props.dahirAmount,
  );
  const [beneficiaries, setBeneficiaries] = useBeneficiaries(
    judgementOnMerits,
    props.judgementAddClone,
    [...get(props, 'jomDeceasedVictims', [])],
    dahirAmountByVictimKey,
    getDeceasedVictims(props.judgementAddClone, {}, currentJudiciaryProcess),
  );
  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState<any>({});
  const [selectedVehicles, setSelectedVehicles] = useState<any>([]);
  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);

  const IsVictimChecked = (victimId: number, selectedVictims: any): boolean => {
    const found = selectedVictims.find((el: any) => el === victimId);
    if (found) return true;
    return false;
  };

  const [
    IsDifficultyExecutionChecked,
    setIsDifficultyExecutionChecked,
  ] = useState<boolean>(false);

  const [isDefenseExecutionChecked, setIsDefenseExecutionChecked] = useState<
    boolean
  >(false);

  const [isRejectionDialogOpen, setIsRejectionDialogOpen] = useState<boolean>(
    false,
  );
  useEffect(() => {
    setJudgementOnMeritsRequest({
      jmv: get(judgementOnMerits, 'judgementOnMerits.jom.jmv', []),
      civjVehicle: get(
        judgementOnMerits,
        'judgementOnMerits.jom.civjVehicle',
        [],
      ),
      civjs: [],
    });
  }, [props.dahirAmount]);

  const handleDifficultyExecutionCheckBox = () => {
    setIsDifficultyExecutionChecked(!IsDifficultyExecutionChecked);
  };

  const handleDefenseExecutionCheckBox = () => {
    setIsDefenseExecutionChecked(!isDefenseExecutionChecked);
  };

  const handleVictimChangeCheckBox = (victimId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const selectedVictim = victims.find((el: any) => el.id === victimId);
    if (event.target.checked) {
      setSelectedVictims([...selectedVictims, selectedVictim.id]);
    } else {
      let uncheckVictimBeneficiaries = { ...selectedBeneficiaries };
      const findBeneficiaryVictim = Object.values(
        uncheckVictimBeneficiaries,
      ).find((beneficiary: any) => beneficiary.victimId === victimId);
      delete uncheckVictimBeneficiaries[
        `${get(findBeneficiaryVictim, 'id', '')}`
      ];
      selectedVictims.splice(
        selectedVictims.findIndex((el: number) => el === victimId),
        1,
      );
      setSelectedVictims([...selectedVictims]);
      setSelectedBeneficiaries(uncheckVictimBeneficiaries);
    }
  };

  const IsVehicleChecked = (
    vehicleId: number,
    selectedVehicles: any,
  ): boolean => {
    const found = selectedVehicles.find((el: any) => el === vehicleId);
    if (found) return true;
    return false;
  };

  const handleVehicleChangeCheckBox = (vehicleId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const selectedVehicle = vehicules.find((el: any) => el.id === vehicleId);

    if (event.target.checked) {
      setSelectedVehicles([...selectedVehicles, selectedVehicle.id]);
    } else {
      selectedVehicles.splice(
        selectedVehicles.findIndex((el: number) => el === vehicleId),
        1,
      );
      setSelectedVehicles([...selectedVehicles]);
    }
  };
  const [
    additionalJudgementOnMeritsInfoForm,
    setAdditionalJudgementOnMeritsInfoForm,
  ] = useState({});

  useDeepCompareEffect(() => {
    if (!isEmpty(props.judgementAdd)) {
      const judgementAddDocuments = get(
        props.judgementAdd,
        'judgementAddDocuments',
        [],
      );
      const victimkeys = uniq(getVictimKeys(judgementAddDocuments, false));

      props.requestGetDahirAmount(
        [
          ...victimkeys,
          ...get(
            get(
              props.judgementAddAppeal,
              'judgementAddDocuments.[0].expertises',
              [],
            ).filter((el: any) => el.expertiseId === 1),
            '[0].victims',
            [],
          ).map((el: any) => el.victimKey),
          ...get(
            get(
              props.judgementAddAppeal,
              'judgementAddDocuments.[0].expertises',
              [],
            ).filter((el: any) => el.expertiseId === 2),
            '[0].victims',
            [],
          ).map((el: any) => el.victimKey),
        ],
        [
          ...without(
            uniq(
              victims
                .filter((v: any) => v['injuryPostKey'] === INJURY_POST_DECEASED)
                .map((v: any) => v.victimKey),
            ),
            null,
            '',
          ),
        ],
      );
    }
  }, [
    props.judgementAdd,
    props.judgementAddAppeal,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
  ]);
  const [formContestationValues, setFormContestationValues] = useState<any>({
    [CONTESTATION.TYPE]: null,
  });
  const [isContestationDrawerOpen, setIsContestationDrawerOpen] = useState(
    false,
  );
  const [openDialogValidation, setOpenDialogValidation] = useState(false);

  const handleFormChange = (fieldName: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) =>
    setFormContestationValues(
      Object.assign(
        {},
        { ...formContestationValues },
        { [fieldName]: event.target.value },
      ),
    );

  const [
    civilJudgementOnMeritsFormMedicalExpertise,
    setCivilJudgementOnMeritsFormMedicalExpertise,
  ] = useState<any>([]);

  const [civilJudgementOnMeritsForm, setCivilJudgementOnMeritsForm] = useState<
    any
  >([]);
  const [
    civilJudgementOnMeritsFormAccountingExpertise,
    setCivilJudgementOnMeritsFormAccountingExpertise,
  ] = useState<any>([]);
  const [
    civilJudgementOnMeritsFormMechanicalExpertise,
    setCivilJudgementOnMeritsFormMechanicalExpertise,
  ] = useState<any>([]);

  const allJudgementAddDocuments = resolveJudgementAddAppeal(
    getJudgementAddDocuments(
      getJudgementAddDocumentsWithoutCivjs(
        props.judgementAddDocuments,
        judgementOnMerits,
      ),
      [],
      judgementOnMerits,
    ),
    false,
    null,
  );

  const [isCJDisabled, setIsCJDisabled] = useState({});

  const getVictims = () =>
    props.isCivilProceeding
      ? civilProceeding.find((cp: any) => cp.id === props.judiciaryProcessId)
          .victims
      : get(props.judgementAdd, 'civilDocuments', [])
          .map((document: any) => get(document, 'victims', []))
          .flat();

  const handleCivJvmChange = (id: any, fieldName: string, victim?: any) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    let victimToUpdate: any =
      civjvmRequest.find((el: any) => el?.id === id) || {};

    const civilJudgementVictims = [...civjvmRequest];
    const index = civilJudgementVictims.findIndex(
      (item: any) => item.id === id,
    );

    if (isEmpty(victimToUpdate) && event.target.name) {
      const substrings = id.split('-');
      addNewJudgementNonCompensation(
        civilJudgementVictims,
        event,
        substrings,
        get(judgementOnMerits, 'judgementOnMerits.jom.id'),
        get(listings, 'civilJudgementVictimReason', []),
        victim,
        INCIDENT_TYPE.VICTIM,
      );
    }
    if (index !== -1) {
      civilJudgementVictims[index] = {
        ...victimToUpdate,
        [fieldName]: event.target.value,
        responsibilityShare: sharedResponsability,
        otherReason: !hasOtherReason(
          get(listings, 'civilJudgementVictimReason', []),
          get(victimToUpdate, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON, ''),
        )
          ? null
          : fieldName === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
          ? event.target.value
          : null,
      };
    }
    setCivjvmRequest(civilJudgementVictims);
  };

  const handleCivjVehicleChange = (
    id: any,
    fieldName: string,
    vehicle?: any,
  ) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    let vehicleToUpdate: any =
      get(judgementOnMeritsRequest, 'civjVehicle', []).find(
        (el: any) => el?.id === id,
      ) || {};

    const civilJudgementVehicles = [
      ...get(judgementOnMeritsRequest, 'civjVehicle', []),
    ];
    const index = civilJudgementVehicles.findIndex(
      (item: any) => item.id === id,
    );

    if (isEmpty(vehicleToUpdate) && event.target.name) {
      const substrings = id.split('-');
      addNewJudgementNonCompensation(
        civilJudgementVehicles,
        event,
        substrings,
        get(judgementOnMerits, 'judgementOnMerits.jom.id'),
        get(listings, 'civilJudgementVictimReason', []),
        vehicle,
        INCIDENT_TYPE.VEHICLE,
      );
    }
    if (index !== -1) {
      civilJudgementVehicles[index] = {
        ...vehicleToUpdate,
        [fieldName]: event.target.value,
        responsibilityShare: sharedResponsability,
        otherReason: !hasOtherReason(
          get(listings, 'civilJudgementVictimReason', []),
          get(vehicleToUpdate, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON, ''),
        )
          ? null
          : fieldName === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
          ? event.target.value
          : null,
      };
    }
    setJudgementOnMeritsRequest({
      ...judgementOnMeritsRequest,
      civjVehicle: civilJudgementVehicles,
    });
  };

  const [isInputChanged, setIsInputChanged] = useState<boolean>(true);

  const handleChangeSharedResponsability = (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    if (parseFloat(e.target.value) >= 0) {
      setIsInputChanged(false);
      setSharedResponsability(e.target.value.replace(',', '.'));
      setCivilJudgementOnMeritsForm(
        getCivilJudgement(judgementOnMerits).map((item: any) => ({
          id: item.id,
          isModified: true,
          responsibilityShare: e.target.value.replace(',', '.'),
        })),
      );
    }
  };

  const [contestationReasons, setContestationReasons] = useState<
    Set<{
      civilJudgementMedicalExpertiseId: number;
      civilJudgementMechanicalExpertiseId: number;
      civilJudgementAccountingExpertiseId: number;
      contestationReasons: Set<number>;
    }>
  >(new Set());

  const [isValidated, setIsValidated] = useState<boolean>(false);

  const [jomStatus, setJomStatus] = useState<string>(
    get(judgementOnMerits, 'judgementOnMerits.status', ''),
  );

  const setContestationReasonsRequest = (
    contestationReasons: Set<{
      civilJudgementMedicalExpertiseId: number;
      civilJudgementMechanicalExpertiseId: number;
      civilJudgementAccountingExpertiseId: number;
      contestationReasons: Set<number>;
    }>,
    correctionalContestationReasons: {
      reasons: Set<number>;
      instruction: string;
    },
    beneficiaryContestationReasons: Set<{
      reasons: [];
      instruction: string;
      judgementOnMeritsBeneficiaryId: number | null;
    }>,
  ) => {
    if (
      isEmpty(contestationReasons) &&
      isEmpty(correctionalContestationReasons.reasons) &&
      isEmpty(beneficiaryContestationReasons)
    ) {
      return {};
    }

    return {
      correctionalJudgement: [
        ...setUpCorrectionalJudgements(correctionalContestationReasons),
      ],
      civilJudgement: [...setUpCivilJudgements(contestationReasons)],
      beneficiary: [...setUpBeneficiary(beneficiaryContestationReasons)],
    };
  };

  const setUpCivilJudgements = (
    contestationReasons: Set<{
      civilJudgementMedicalExpertiseId: number;
      civilJudgementMechanicalExpertiseId: number;
      civilJudgementAccountingExpertiseId: number;
      contestationReasons: any;
    }>,
  ) => {
    const civilJudgements = [];
    for (let item of contestationReasons) {
      for (let reason of item.contestationReasons) {
        civilJudgements.push({
          ...item,
          judgementOnMeritsContestationReasonId: reason,
        });
      }
    }
    civilJudgements.forEach(el => delete el.contestationReasons);
    return civilJudgements;
  };

  const setUpBeneficiary = (
    beneficiaryContestationReasons: Set<{
      reasons: any;
      instruction: string;
      judgementOnMeritsBeneficiaryId: number | null;
    }>,
  ) => {
    const beneficiaryContestation = [];
    for (let item of beneficiaryContestationReasons) {
      for (let reason of item.reasons) {
        beneficiaryContestation.push({
          ...item,
          judgementOnMeritsBeneficiaryContestationReasonId: reason,
        });
      }
    }
    beneficiaryContestation.forEach(el => delete el.reasons);
    return beneficiaryContestation;
  };

  const setUpCorrectionalJudgements = (correctionalContestationReasons: {
    reasons: Set<number>;
    instruction: string;
  }) => {
    const correctionalJudgements = [];
    for (let item of correctionalContestationReasons.reasons) {
      correctionalJudgements.push({
        correctionalJudgementId:
          judgementOnMerits['judgementOnMerits']['jom']['cj']['id'],
        judgementOnMeritsContestationReasonId: item,
        instruction: correctionalContestationReasons.instruction,
      });
    }
    return correctionalJudgements;
  };
  const [
    correctionalContestationReasons,
    setCorrectionalContestationReasons,
  ] = useState<{
    reasons: Set<number>;
    instruction: string;
  }>({ reasons: new Set(), instruction: '' });
  const [
    beneficiaryContestationReasons,
    setBeneficiaryContestationReasons,
  ] = useState<
    Set<{
      reasons: [];
      instruction: string;
      judgementOnMeritsBeneficiaryId: number | null;
    }>
  >(new Set());

  const nextOfKins = formatNextOfKins(beneficiaries, sharedResponsability);

  const isValidatedWithoutContestation =
    isEmpty(contestationReasons) &&
    isEmpty(correctionalContestationReasons.reasons) &&
    !isBeneficiaryNotEmpty(beneficiaryContestationReasons) &&
    !isContested(judgementOnMerits) &&
    isEmpty(
      get(judgementOnMerits, 'beneficiaries', []).filter(
        (el: any) => !isEmpty(el.contest),
      ),
    );

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );
  const claimRecap = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap']),
  );

  const deceasedVictimInJom = useMemo(
    () =>
      resolveSlectedDeceasedVictims(
        getDeceasedVictims(
          props.judgementAdd,
          props.judgementAddAppeal,
          currentJudiciaryProcess,
        ),
        [...props.jomAssociatedVictims, ...props.jomDeceasedVictims],
        get(judgementOnMerits, 'judgementOnMerits.jom.id', ''),
        props.isMultiple,
      ),
    [],
  );
  const validateDesceasedVictim = shouldValidateDesceasedVictims(
    deceasedVictim,
    get(listings, 'civilJudgementVictimReason', []),
    get(judgementOnMeritsRequest, 'jmv', []),
    props,
  );

  const handleValidateJudgementOnMerits = (
    isValidated: boolean,
    toUpdate: boolean,
  ) => () => {
    props.setIsButtonRedirect && props.setIsButtonRedirect(true);
    const contestationType = get(
      listings,
      'judgementOnMeritsContestationTypes',
      [],
    ).find(el => el.id === formContestationValues[CONTESTATION.TYPE])?.title;
    const codeIntervenant = get(claim, 'assignment.assignedLawyer');
    const reasonWithoutCompensationEvaluations = mapReasonWithoutCompensationEvaluations(
      civjvmRequest,
      sharedResponsability,
      claim,
      judgementOnMeritsInfo,
      judgementOnMeritsInfoForm,
      judgementOnMerits,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      expertiseReport,
    );

    const sagisEvaluationWithoutExpertise = mapSagisEvaluationWithoutExpertise(
      victims,
      expertiseReport,
      judgementOnMerits,
      judgementOnMeritsRequest,
      civilJudgementOnMeritsFormMedicalExpertise,
      sharedResponsability,
      civilJudgementOnMeritsFormAccountingExpertise,
      judgement,
      civjvmRequest,
      newCivjvm,
      additionalJudgementOnMeritsInfoForm,
      judgementOnMeritsInfoForm,
      claim,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      props.judgementAddDocuments,
      props.judiciaryProcessId,
    );

    const sagisEvaluations = mapSagisEvaluation(
      expertiseReport,
      deceasedVictim,
      victimsEvaluationsToInclude,
      judgement,
      civjvmRequest,
      newCivjvm,
      civilJudgements,
      judgementOnMeritsRequest,
      civilJudgementOnMeritsFormMedicalExpertise,
      civilJudgementOnMeritsFormAccountingExpertise,
      civilJudgementOnMeritsForm,
      responsibilityRate,
      victims,
      additionalJudgementOnMeritsInfoForm,
      claim,
      judgementOnMerits,
      judgementOnMeritsInfoForm,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      props.isMultiple,
      props.judiciaryProcessId,
      props.dahirAmount,
    );
    const sagisEvalVictimKeys =
      sagisEvaluations && sagisEvaluations.map((el: any) => el?.victimKey);

    const civilDocumentsEvaluations = mapCivilDocumentsEvaluations(
      deceasedVictim,
      sagisEvalVictimKeys,
      victimsEvaluationsToInclude,
      judgementOnMeritsRequest,
      claim,
      additionalJudgementOnMeritsInfoForm,
      judgementOnMerits,
      judgementOnMeritsInfoForm,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      props.isMultiple,
      props.judiciaryProcessId,
    );

    const civilDocumentsVictimKeys =
      civilDocumentsEvaluations &&
      civilDocumentsEvaluations.map((el: any) => el.victimKey);

    const judiciaryProcessEvaluations = mapJudiciaryProcessEvaluations(
      currentJudiciaryProcess,
      beneficiaries,
      sagisEvalVictimKeys,
      civilDocumentsVictimKeys,
      victimsEvaluationsToInclude,
      deceasedVictim,
      judgementOnMeritsRequest,
      judgementOnMerits,
      additionalJudgementOnMeritsInfoForm,
      judgementOnMeritsInfoForm,
      claim,
      getVictims(),
      get(listings, 'civilJudgementVictimReason', []),
      props.isMultiple,
      props.judiciaryProcessId,
    );

    const sagisEvals = [
      ...mergeEvaluationsV2(
        [
          ...sagisEvaluations,
          ...civilDocumentsEvaluations,
          ...judiciaryProcessEvaluations,
        ],
        sharedResponsability,
      ),
      ...sagisEvaluationWithoutExpertise,
      ...reasonWithoutCompensationEvaluations,
    ];
    const validationRequest = {
      contestation: {},
      toUpdate,
      isAppealed: !isValidatedWithoutContestation,
      isContested: isContestationDrawerOpen,
      status: toUpdate
        ? jomStatus
        : isValidatedWithoutContestation
        ? PROCEDURE_STATUSES.VALIDATED_WITHOUT_CONTESTATION
        : PROCEDURE_STATUSES.APPEL,
      claimId: Number(claimId),
      claimNumber,
      claimExtCode: claimNumber,
      contestationReasons: setContestationReasonsRequest(
        contestationReasons,
        correctionalContestationReasons,
        beneficiaryContestationReasons,
      ),
      rejectionReason: get(
        judgementOnMerits,
        'judgementOnMerits.rejectionReason',
      ),
      jomId: get(judgementOnMerits, 'judgementOnMerits.jom.id', ''),
      isMultiple: props.isMultiple,
      //to-add
      invoiceFeeNotes: [],
      jomDate: moment(
        get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate'),
      ).format('DD/MM/YYYY'),
      judgementId: get(judgementOnMerits['judgementOnMerits'], 'id'),
      info: {
        id: judgementOnMerits['judgementOnMerits']['jom']['id'],
        ...judgementOnMeritsInfoForm,
        ...additionalJudgementOnMeritsInfoForm,
      },
      document: {
        ...judgementOnMeritsFormDocument,
        judgementOnMeritsId:
          judgementOnMerits['judgementOnMerits']['jom']['id'],
        id:
          get(judgementOnMerits['judgementOnMerits']['jom'], 'document.id') &&
          get(judgementOnMerits['judgementOnMerits']['jom'], 'document.id'),
      },
      correctionalInfo: [
        ...correctionalJudgementOnMeritsForm.filter((el: any) => el.isModified),
      ],
      beneficiaries,
      civilInfo: [
        ...civilJudgementOnMeritsForm.filter((el: any) => el.isModified),
      ],
      medExpertises: formatMedExpertises(
        civilJudgementOnMeritsFormMedicalExpertise,
      ),
      accExpertises: formatAccExpertises(
        civilJudgementOnMeritsFormAccountingExpertise,
      ),
      mechanicalExpertises: formatMechanicalExpertises(
        civilJudgementOnMeritsFormMechanicalExpertise,
      ),
      newCivjs: get(judgementOnMeritsRequest, 'civjs', []).map((el: any) => ({
        ...el,
        responsibilityShare: parseFloat(sharedResponsability as any),
      })),
      newCivjvm: Object.values(get(judgementOnMeritsRequest, 'civjvm', []))
        .filter((item: any) => !isEmpty(item))
        .map((el: any) => ({
          ...el,
          responsibilityShare: parseFloat(sharedResponsability as any),
        })),
      civjvmInfo: civjvmRequest,
      civjVehicleInfo: Object.values(
        get(judgementOnMeritsRequest, 'civjVehicle', []),
      ).filter((item: any) => !isEmpty(item)),
      jmv: getJudgementOnMeritsVictims(
        civilJudgements,
        judgementOnMerits,
        props.judgementAddClone,
        {},
        currentJudiciaryProcess,
        dahirAmountByVictimKey,
        parseFloat(sharedResponsability),
        get(judgementOnMeritsRequest, 'jmv', []),
        props.jomAssociatedVictims,
        props.jomDeceasedVictims,
        props.isMultiple,
      ),
      procedureType: PROCEDURE_TYPES.FIRST_INSTANCE,
      feeNote: {
        step: LEGAL_PROCEEDINGS_STEPS.JUDGEMENT_ON_MERITS,
        codeIntervenant: codeIntervenant,
      },
      deceasedVictims: getDeceasedVictim(
        deceasedVictim,
        props.judgementAddClone,
        sharedResponsability as any,
      ),
      fflipFeeNote: featureService.hasFeature(FEATURES.FEE_NOTE),
      username: currentUserStorage.get().username,
      judiciaryProcessId: get(
        judgementOnMerits['judgementOnMerits'],
        'judiciaryProcessId',
      ),
      sagisEvaluations:
        toUpdate &&
        (jomStatus === STATUS_PENDING || jomStatus === STATUS_REJECTED)
          ? []
          : [...sagisEvals],
      priorityClaimReasonId:
        priorityReasonClaimId != 4 &&
        featureService.hasFeature(FEATURES.PRIORITY_CLAIM)
          ? priorityClaimReason(
              [...sagisEvals],
              !isEmpty(get(resolveSagisClaim(policyInfo), 'offeredRisks', []))
                ? get(resolveSagisClaim(policyInfo), 'offeredRisks', [])
                    .map((el: any) => Number(el.riskProvisions))
                    .reduce(
                      (accumulator: any, currentValue: any) =>
                        accumulator + currentValue,
                    )
                : 0,
              listings,
            )
          : undefined,
      provisionBody:
        toUpdate &&
        (jomStatus === STATUS_PENDING || jomStatus === STATUS_REJECTED)
          ? undefined
          : {
              riskID: get(
                resolveSagisClaim(policyInfo),
                'offeredRisks',
                [],
              ).find(
                (element: { riskName: string }) =>
                  element.riskName === rcCoporeal,
              )?.riskId,
              date: moment().toISOString(true),
            },
      nextOfKins:
        toUpdate &&
        (jomStatus === STATUS_PENDING || jomStatus === STATUS_REJECTED)
          ? undefined
          : nextOfKins,
      isInboxesActive: featureService.hasFeature(
        FEATURES.ATTRIBUTION_INBOXES_MANAGER,
      ),
      isPriorityActive: featureService.hasFeature(FEATURES.PRIORITY_CLAIM),
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      isLawyerInboxesActive: featureService.hasFeature(FEATURES.LAWYER_INBOXES),
    };

    if (isContestationDrawerOpen) {
      validationRequest.status = PROCEDURE_STATUSES.OPPOSITION;
      validationRequest.contestation = {
        ...formContestationValues,
        victims: selectedVictims,
        beneficiaries: Object.values(selectedBeneficiaries),
        vehicules: selectedVehicles,
        contestationType,
        judgementOnMeritsId: get(
          judgementOnMerits,
          'judgementOnMerits.jom.id',
          '',
        ),
        difficultyExecution: IsDifficultyExecutionChecked,
        defenseExecution: isDefenseExecutionChecked,
      };
    }
    requestValidateJudgementOnMerits(
      validationRequest,
      successCallBack(toUpdate),
    );
    setIsValidated(isValidated);
    setJomStatus(
      isValidatedWithoutContestation
        ? PROCEDURE_STATUSES.VALIDATED_WITHOUT_CONTESTATION
        : PROCEDURE_STATUSES.APPEL,
    );
  };

  const successCallBack = (toUpdate: boolean) => () => {
    !toUpdate
      ? toast.success(
          translate(
            messages.courtManagerValidationDialogSuccessMessage,
            props,
            { lawyer },
          ),
        )
      : toast.success(
          translate(messages.updatedStepSuccessMessage, props, {
            lawyer,
          }),
        );
    openDialogValidation && setOpenDialogValidation(false);
    featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)
      ? !isContestationDrawerOpen &&
        !toUpdate &&
        props.setOpenFeeNoteDialog(true)
      : pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)();
  };

  const [
    judgementOnMeritsFormDocument,
    setJudgementOnMeritsFormDocument,
  ] = useState({ ...EMPTY_JUDGEMENT_ON_MERITS_DOC });

  const [
    correctionalJudgementOnMeritsForm,
    setCorrectionalJudgementOnMeritsForm,
  ] = useState<any>([]);

  const [isAddJomDrawerOpen, setIsAddJomDrawerOpen] = useState(false);

  const [associatedVictims, setAssociatedVictims] = useState<any>([]);
  const [associatedVehicles, setAssociatedVehicles] = useState<any>([]);

  const handleToggleAddJomDrawer = () => {
    setIsAddJomDrawerOpen(!isAddJomDrawerOpen);
  };

  const handleSubmitCreateJom = () => {
    setIsAddJomDrawerOpen(false);
    if (setJomLabels) setJomLabels([messages.judgementOnMeritsLabelTitle]);
    if (props.setJomAssociatedVictims)
      props.setJomAssociatedVictims(associatedVictims);
  };
  const allJudgementDocuments = useMemo(
    () =>
      getJudgementAddDocuments(
        props.judgementAddDocuments,
        [],
        judgementOnMerits,
      ),
    [props.judgementAddDocuments, judgementOnMerits],
  );
  const validateCivilJudgements = validateCivilJudgementsOnRecap(
    filterExpertises(
      formatExpertisesWithExpertReport(
        allJudgementDocuments,
        get(expertiseReport, 'victimExpertises', []),
        get(expertiseReport, 'vehiculeExpertises', []),
      ),
    ),
    formatExpertisesWithExpertReport(
      allJudgementDocuments,
      get(expertiseReport, 'victimExpertises', []),
      get(expertiseReport, 'vehiculeExpertises', []),
    ),
    judgement,
    civilJudgementOnMeritsFormMedicalExpertise,
    civilJudgementOnMeritsFormAccountingExpertise,
    civilJudgementOnMeritsFormMechanicalExpertise,
    civjvmRequest,
    get(judgementOnMeritsRequest, 'civjVehicle', []),
    get(listings, 'civilJudgementVictimReason', []),
    get(judgementOnMeritsRequest, 'civjs', []),
    get(judgementOnMeritsRequest, 'civjvm', {}),
    isCJDisabled,
    judgementOnMerits,
  );

  const resolveDropDownMenuElements = () => {
    const updateJom =
      featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
      props.isManager &&
      jomStatus !== PROCEDURE_STATUSES.PENDING
        ? ({
            title: translate(messages.updateJom, props),
            action: () => handleValidateJudgementOnMerits(true, true)(),
            disabled:
              (!featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
                !props.isManager) ||
              disableOnValidationButton(
                judgementOnMeritsInfoForm,
                validateDesceasedVictim,
                getAllBeneficiaries(deceasedVictim),
                validateCivilJudgements,
                sharedResponsability,
                civilJudgementOnMeritsFormMedicalExpertise,
                civilJudgementOnMeritsFormAccountingExpertise,
                civilJudgementOnMeritsFormMechanicalExpertise,
                get(listings, 'civilJudgementVictimReason', []),
                get(judgementOnMeritsRequest, 'civjs', []),
                getVictims(),
                civjvmRequest,
                allJudgementDocuments,
              ),
          } as any)
        : {};
    const addJom = [
      {
        title: translate(messages.addJom, props),
        action: () => setIsAddJomDrawerOpen(true),
        disabled:
          (!props.isCivilProceeding &&
            !featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)) ||
          !featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER),
      },
    ];
    const pendingDropdown = [
      {
        title: translate(messages.validateWithoutContestation, props),
        action: () =>
          jomStatus === PROCEDURE_STATUSES.REJECTED &&
          featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)
            ? setOpenDialogValidation(true)
            : handleValidateJudgementOnMerits(false, false)(),
        disabled:
          !isEmpty(contestationReasons) ||
          isExpertReportNotValidated ||
          !isEmpty(correctionalContestationReasons.reasons) ||
          isBeneficiaryNotEmpty(beneficiaryContestationReasons) ||
          disableOnValidationButton(
            {
              ...judgementOnMeritsInfoForm,
              createdAt: get(
                judgementOnMerits,
                'judgementOnMerits.jom.createdAt',
                '',
              ),
            },
            validateDesceasedVictim,
            getAllBeneficiaries(deceasedVictim),
            validateCivilJudgements,
            sharedResponsability,
            civilJudgementOnMeritsFormMedicalExpertise,
            civilJudgementOnMeritsFormAccountingExpertise,
            civilJudgementOnMeritsFormMechanicalExpertise,
            get(listings, 'civilJudgementVictimReason', []),
            get(judgementOnMeritsRequest, 'civjs', []),
            getVictims(),
            civjvmRequest,
            props.judgementAddDocuments,
          ),
      },
      {
        title: translate(messages.reject, props),
        action: () => setIsRejectionDialogOpen(true),
      },
      {
        title: translate(messages.contest, props),
        action: () => {
          handleValidateJudgementOnMerits(true, false)();
        },
        disabled:
          (isEmpty(contestationReasons) &&
            isEmpty(correctionalContestationReasons.reasons) &&
            !isBeneficiaryNotEmpty(beneficiaryContestationReasons)) ||
          (isEmpty(contestationReasons) &&
          isEmpty(correctionalContestationReasons.reasons) &&
          !isBeneficiaryNotEmpty(beneficiaryContestationReasons) &&
          !isContested(judgementOnMerits) &&
          isEmpty(
            get(judgementOnMerits, 'beneficiaries', []).filter(
              (el: any) => !isEmpty(el.contest),
            ),
          )
            ? isValidatedWithoutContestation
            : false) ||
          disableOnValidationButton(
            judgementOnMeritsInfoForm,
            validateDesceasedVictim,
            getAllBeneficiaries(deceasedVictim),

            validateCivilJudgements,
            sharedResponsability,
            civilJudgementOnMeritsFormMedicalExpertise,
            civilJudgementOnMeritsFormAccountingExpertise,
            civilJudgementOnMeritsFormMechanicalExpertise,
            get(listings, 'civilJudgementVictimReason', []),
            get(judgementOnMeritsRequest, 'civjs', []),
            getVictims(),
            civjvmRequest,
            props.judgementAddDocuments,
          ),
      },
      {
        title: translate(messages.contestationType, props),
        action: () => setIsContestationDrawerOpen(true),
        disabled:
          (isEmpty(contestationReasons) &&
            isEmpty(correctionalContestationReasons.reasons) &&
            !isBeneficiaryNotEmpty(beneficiaryContestationReasons)) ||
          (isEmpty(contestationReasons) &&
          isEmpty(correctionalContestationReasons.reasons) &&
          !isBeneficiaryNotEmpty(beneficiaryContestationReasons) &&
          !isContested(judgementOnMerits) &&
          isEmpty(
            get(judgementOnMerits, 'beneficiaries', []).filter(
              (el: any) => !isEmpty(el.contest),
            ),
          )
            ? isValidatedWithoutContestation
            : false),
      },
    ];
    const rejectedDropDown = [...pendingDropdown, ...addJom];
    const dropdown =
      jomStatus === PROCEDURE_STATUSES.PENDING
        ? pendingDropdown
        : jomStatus === PROCEDURE_STATUSES.REJECTED
        ? rejectedDropDown
        : [
            {
              title: translate(messages.contest, props),
              action: () => {
                handleValidateJudgementOnMerits(true, false)();
              },
              disabled:
                (!isContested(judgementOnMerits) &&
                isEmpty(
                  get(judgementOnMerits, 'beneficiaries', []).filter(
                    (el: any) => !isEmpty(el.contest),
                  ),
                )
                  ? isValidatedWithoutContestation
                  : false) ||
                (isEmpty(contestationReasons) &&
                  isEmpty(correctionalContestationReasons.reasons) &&
                  !isBeneficiaryNotEmpty(beneficiaryContestationReasons)) ||
                (isEmpty(contestationReasons) &&
                isEmpty(correctionalContestationReasons.reasons) &&
                !isBeneficiaryNotEmpty(beneficiaryContestationReasons) &&
                !isContested(judgementOnMerits) &&
                isEmpty(
                  get(judgementOnMerits, 'beneficiaries', []).filter(
                    (el: any) => !isEmpty(el.contest),
                  ),
                )
                  ? isValidatedWithoutContestation
                  : false) ||
                disableOnValidationButton(
                  judgementOnMeritsInfoForm,
                  validateDesceasedVictim,
                  getAllBeneficiaries(deceasedVictim),
                  validateCivilJudgements,
                  sharedResponsability,
                  civilJudgementOnMeritsFormMedicalExpertise,
                  civilJudgementOnMeritsFormAccountingExpertise,
                  civilJudgementOnMeritsFormMechanicalExpertise,
                  get(listings, 'civilJudgementVictimReason', []),
                  get(judgementOnMeritsRequest, 'civjs', []),
                  getVictims(),
                  civjvmRequest,
                  props.judgementAddDocuments,
                ),
            },
            {
              title: translate(messages.contestationType, props),
              action: () => setIsContestationDrawerOpen(true),
              disabled:
                !isContested(judgementOnMerits) &&
                isEmpty(
                  get(judgementOnMerits, 'beneficiaries', []).filter(
                    (el: any) => !isEmpty(el.contest),
                  ),
                )
                  ? isValidatedWithoutContestation
                  : false,
            },
            ...addJom,
            {
              title: translate(messages.addJomAppeal, props),
              action: () => setIsAppealDialogOpen(true),
              disabled:
                (!props.isCivilProceeding &&
                  !(jomStatus === PROCEDURE_STATUSES.APPEL) &&
                  featureService.hasFeature(
                    FEATURES.MANAGE_CLAIM_BY_MANAGER,
                  )) ||
                (!(jomStatus === PROCEDURE_STATUSES.APPEL) &&
                  !featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)),
            },
          ];

    return !isEmpty(updateJom) ? [...dropdown, updateJom] : dropdown;
  };

  useEffect(() => {
    if (!isEmpty(judgementOnMerits)) {
      const suedParties =
        get(
          judgementOnMerits['judgementOnMerits']['jom']['cj'],
          'suedPartys',
        ) &&
        get(
          judgementOnMerits['judgementOnMerits']['jom']['cj'],
          'suedPartys',
        ).map(el => {
          return {
            id: el.id,
            condamnation: el.condamnation,
            suedPartyId: el.suedPartyId,
            isModified: false,
          };
        });
      const responsabilityShares = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        return {
          id: el.id,
          responsibilityShare: el.responsibilityShare,
          isModified: false,
        };
      });
      const civjVictimAccountings = civilJudgements
        .flatMap((item: any) => item.civjacce)
        .filter((el: any) => !!el.victim);
      const medicalExpertises = judgementOnMerits['judgementOnMerits']['jom'][
        'civjs'
      ].map(el => {
        const medExpertises = el['civjmede'].map((item: any) => {
          const accountingExpertise =
            civjVictimAccountings.find(el => el.victimId === item.victimId) ||
            {};
          return {
            id: item.id,
            compensationAmount: item.compensationAmount,
            provisionalExecution: item.provisionalExecution,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            victimId: item?.victimId,
            evaluationAmount: get(
              accountingExpertise,
              'evaluationAmount',
              null,
            ),
          };
        });
        return {
          id: el.id,
          medExpertises: [...medExpertises],
        };
      });
      const accountingExpertises = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        const accExpertises = el['civjacce'].map((item: any) => {
          return {
            id: item.id,
            evaluationAmount: item.evaluationAmount,
            calculatedRevenue: item.calculatedRevenue,
            provisionalExecution: item.provisionalExecution,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            victimId: get(item, 'victimId', null),
            vehiculeId: get(item, 'vehiculeId', null),
          };
        });
        return {
          id: el.id,
          accExpertises: [...accExpertises],
        };
      });
      const mechanicalExpertises = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        const mechanicalExpertise = get(el, 'civjmece', []).map((item: any) => {
          return {
            id: item.id,
            damageAmount: item.damageAmount,
            provisionalExecution: item.provisionalExecution,
            expertiseJudgmentAddDocumentId:
              item?.expertiseJudgmentAddDocumentId,
            vehiculeId: item?.vehiculeId,
          };
        });
        return {
          id: el.id,
          mechanicalExpertise: [...mechanicalExpertise],
        };
      });
      if (suedParties) {
        setCorrectionalJudgementOnMeritsForm([...suedParties]);
      }
      setCivilJudgementOnMeritsForm([...responsabilityShares]);
      setCivilJudgementOnMeritsFormMedicalExpertise([...medicalExpertises]);
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...accountingExpertises,
      ]);
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...mechanicalExpertises,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [judgementOnMerits, props.judiciaryProcessId]);

  const handleCorrectionalCondamnationChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    const found = correctionalJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.condamnation = e.target.value;
    }
    setCorrectionalJudgementOnMeritsForm([
      ...correctionalJudgementOnMeritsForm,
    ]);
  };

  const handleMedExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormMedicalExpertiseData = [
      ...civilJudgementOnMeritsFormMedicalExpertise,
    ];
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementMed = civilJudgementOnMeritsFormMedicalExpertise.find(
      (item: any) => item.id === id,
    );
    const civilJudgementData = [...civilJudgements];

    const medExp =
      get(civilJudgementMed, 'medExpertises', []).find(
        (item: any) => item.id === expertiseId,
      ) || {};
    const accountingExp = props.judgementAddDocuments
      .map((el: any) => {
        const victimExpertise = get(el, 'expertises', [])
          .filter(
            (item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
          )
          .flatMap((expertise: any) => expertise.victims)
          .find((victim: VictimType) => victim.id === incident.id);
        return {
          id: el.id,
          expertiseJudgementAddDocumentId: get(
            victimExpertise,
            'expertiseJudgementAddDocumentId',
          ),
          victimId: get(victimExpertise, 'id'),
        };
      })
      .find((item: any) => !!item?.expertiseJudgementAddDocumentId);
    const accountingCivj = civilJudgements.find(
      (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
    );
    if (isEmpty(medExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormMedicalExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.MEDICAL,
        incidentType,
        incident,
      );
      !isEmpty(accountingExp) &&
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addNewCivjJudgement(
          get(accountingCivj, 'id'),
          civilJudgements,
          `${get(accountingExp, 'victimId')}-${get(
            accountingExp,
            'expertiseJudgementAddDocumentId',
          )}`,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          e,
          CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
          incidentType,
          incident,
        );
      setCivilJudgementOnMeritsFormMedicalExpertise(
        civilJudgementOnMeritsFormMedicalExpertiseData,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(medExp)) {
      const civjWithoutCompensation = [...civjvmRequest];
      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addAccountingExpertiseAfterMerge(
          civilJudgements,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          medExp,
          type,
          e,
          civjWithoutCompensation,
          setCivjvmRequest,
          accountingExp,
        );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgementOnMeritsFormMedicalExpertise([
        ...civilJudgementOnMeritsFormMedicalExpertise.filter(
          (el: any) => el.id !== civilJudgementMed?.id,
        ),
        {
          id: civilJudgementMed?.id,
          medExpertises: [
            ...get(civilJudgementMed, 'medExpertises', []).filter(
              (el: any) => el.id !== medExp.id,
            ),
            {
              ...medExp,
              id: medExp.id,
              compensationAmount:
                type === 0
                  ? e.target.value.replace(',', '.')
                  : medExp.compensationAmount,
              evaluationAmount:
                type === 2
                  ? e.target.value.replace(',', '.')
                  : medExp.evaluationAmount,
              provisionalExecution:
                type === 1
                  ? e.target.value.replace(',', '.')
                  : medExp.provisionalExecution,
            },
          ],
        },
      ]);
    }
  };

  const handleAccExpertiseChange = (id: number) => (
    expertiseId: any,
    type: number,
    incidentType: string,
    incident: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgement = civilJudgementOnMeritsFormAccountingExpertiseData.find(
      (item: any) => item.id === id,
    );
    const civilJudgementData = [...civilJudgements];
    const accExp =
      civilJudgement.accExpertises.find(
        (item: any) => item.id === expertiseId,
      ) || {};
    if (isEmpty(accExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormAccountingExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
        incidentType,
        incident,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(accExp)) {
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...civilJudgementOnMeritsFormAccountingExpertiseData.filter(
          (el: any) => el.id !== civilJudgement.id,
        ),
        {
          id: civilJudgement.id,
          accExpertises: [
            ...civilJudgement.accExpertises.filter(
              (el: any) => el.id !== accExp.id,
            ),
            {
              ...accExp,
              id: accExp.id,
              evaluationAmount:
                type === 0
                  ? e.target.value.replace(',', '.')
                  : accExp.evaluationAmount,
              provisionalExecution:
                type === 1
                  ? e.target.value.replace(',', '.')
                  : accExp.provisionalExecution,
              calculatedRevenue:
                type === 2
                  ? e.target.value.replace(',', '.')
                  : accExp.calculatedRevenue,
            },
          ],
        },
      ]);
    }
  };

  const handleMechanicalExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormMechanicalExpertiseData = [
      ...civilJudgementOnMeritsFormMechanicalExpertise,
    ];
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementData = [...civilJudgements];

    const civilJudgementMec = civilJudgementOnMeritsFormMechanicalExpertiseData.find(
      (item: any) => item.id === id,
    );
    const accountingExp = props.judgementAddDocuments
      .map((el: any) => {
        const vehicleExpertise = get(el, 'expertises', [])
          .filter(
            (item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
          )
          .flatMap((expertise: any) => expertise.vehicules)
          .find((vehicle: any) => vehicle.id === incident.id);

        return {
          id: el.id,
          expertiseJudgementAddDocumentId: get(
            vehicleExpertise,
            'expertiseJudgementAddDocumentId',
          ),
          vehiculeId: get(vehicleExpertise, 'id'),
        };
      })
      .find((item: any) => !!item?.expertiseJudgementAddDocumentId);

    const accountingCivj = civilJudgements.find(
      (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
    );
    const meceExp = get(civilJudgementMec, 'mechanicalExpertise', []).find(
      (item: any) => item.id === expertiseId,
    );
    if (isEmpty(meceExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormMechanicalExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.MECHANICAL,
        incidentType,
        incident,
      );
      !isEmpty(accountingExp) &&
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addNewCivjJudgement(
          get(accountingCivj, 'id'),
          civilJudgements,
          `${get(accountingExp, 'vehiculeId')}-${get(
            accountingExp,
            'expertiseJudgementAddDocumentId',
          )}`,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          e,
          CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
          incidentType,
          incident,
        );
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...civilJudgementOnMeritsFormMechanicalExpertiseData,
      ]);
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(meceExp)) {
      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        updateVehicleAccountingExpertiseAfterMerge(
          civilJudgements,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          meceExp,
          type,
          e,
          accountingExp,
        );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...civilJudgementOnMeritsFormMechanicalExpertise.filter(
          (el: any) => el.id !== civilJudgementMec.id,
        ),
        {
          id: civilJudgementMec.id,
          mechanicalExpertise: [
            ...civilJudgementMec.mechanicalExpertise.filter(
              (el: any) => el.id !== meceExp.id,
            ),
            {
              ...meceExp,
              id: meceExp.id,
              damageAmount: type
                ? meceExp.damageAmount
                : e.target.value.replace(',', '.'),
              provisionalExecution: !type
                ? meceExp.provisionalExecution
                : e.target.value.replace(',', '.'),
            },
          ],
        },
      ]);
    }
  };

  const handleCivilResponsabilityShareChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    const found = civilJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.responsibilityShare = e.target.value.replace(',', '.');
    }
    setCivilJudgementOnMeritsForm([...civilJudgementOnMeritsForm]);
    setResponsibilityRate(e.target.value.replace(',', '.'));
  };

  const handleCorrectionalSelectChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: unknown }>,
  ) => {
    const found = correctionalJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.suedPartyId = e.target.value;
    }
    setCorrectionalJudgementOnMeritsForm([
      ...correctionalJudgementOnMeritsForm,
    ]);
  };

  const isBeneficiaryChecked = (beneficiaryId: number) => {
    return Object.values(selectedBeneficiaries).find(
      ({ id }: any) => id === beneficiaryId,
    )
      ? true
      : false;
  };
  const handleBeneficiaryCheckBox = (
    victimId: number,
    beneficiaryId: number,
    beneficiaries: [{ id: number; victimId: number }],
  ) => (
    event: React.ChangeEvent<{ id: string; value: string; checked: boolean }>,
  ) => {
    const selectedBeneficiary: any = beneficiaries.find(
      (el: any) => el.id === beneficiaryId,
    );

    if (event.target.checked) {
      setSelectedBeneficiaries({
        ...selectedBeneficiaries,
        ...{
          [selectedBeneficiary.id]: { id: selectedBeneficiary.id, victimId },
        },
      });
    } else {
      let selectedBeneficiary = { ...selectedBeneficiaries };
      delete selectedBeneficiary[
        `${Object.keys(selectedBeneficiary).find(
          (el: any) => Number(el) === beneficiaryId,
        )}`
      ];
      setSelectedBeneficiaries(selectedBeneficiary);
    }
  };
  const hasValidator = showValidator(
    get(judgementOnMerits, 'judgementOnMerits.validator', ''),
    props.isManager,
  );
  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );

  const currentlawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const successCallBackArchive = () => {
    toast.success(translate(messages.archiveSuccessToast, props));
  };
  const handleValidateArchiveJudgement = () => {
    props.requestArchiveJudgement &&
      props.requestArchiveJudgement(
        {
          claimId: claimId,
          archiveReason: archiveReason,
          judgementId: get(judgementOnMerits, 'judgementOnMerits.id'),
          procedureType: get(
            judgementOnMerits,
            'judgementOnMerits.procedureType',
          ),
          judiciaryProcessId: get(
            judgementOnMerits,
            'judgementOnMerits.judiciaryProcessId',
          ),
        },
        successCallBackArchive,
      );
  };
  const handleChange = (e: React.ChangeEvent<{ value: string }>) => {
    setArchiveReason((e.target.value as unknown) as string);
  };
  return (
    <Container id="judgement-on-merits-wrapper">
      {userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
        !props.isConsultation &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISJUDGEMENTARCHIVEMANAGER) &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              style={{ ...(StyledSecondaryButton as any) }}
              data-testId={'reject-transaction-button'}
              onClick={handleOpenDialog}
            >
              <Grid container direction="row" alignItems="center">
                <Grid item>
                  <img
                    src={deleteIcon}
                    style={{ marginTop: '4px' }}
                    alt="delete-icon"
                  />
                </Grid>
                <Grid item>
                  <span>
                    {translate(messages.archiveJudgementTitle, props)}
                  </span>
                </Grid>
              </Grid>
            </Button>
          </div>
        )}
      {
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {!isUserActive(
            listings,
            get(currentlawyerAssignment, 'assignedLawyer'),
          ) &&
          !isEmpty(currentlawyerAssignment) &&
          !isEmpty(listings)
            ? translate(messages.userNotValidWarning, props, {
                lawyerName: getValueByCode(
                  get(currentlawyerAssignment, 'assignedLawyer', ''),
                  get(listings, 'inactiveIntervenants', []),
                ),
              })
            : ''}
        </div>
      }
      {
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
          {get(judgementOnMerits, 'judgementOnMerits.creator', '')
            ? translate(messages.creatorTitle, props, {
                lawyer: get(judgementOnMerits, 'judgementOnMerits.creator', ''),
              })
            : ''}
        </span>
      }
      {hasValidator && jomStatus !== PROCEDURE_STATUSES.PENDING && (
        <ValidatorRecap
          validator={get(judgementOnMerits, 'judgementOnMerits.validator', '')}
        />
      )}
      <UpdateStepRecap
        updatedBy={get(judgementOnMerits, 'judgementOnMerits.updatedBy', '')}
      />
      <div>
        <div className="judgement-on-merits-title">
          {translate(messages.judgementOnMeritsInfo, props, {
            jomId: !isNil(
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.judgementDate',
                null,
              ),
            )
              ? props.intl.formatDate(
                  get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate'),
                  {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  },
                )
              : '',
          })}
          {get(judgementOnMerits, 'judgementOnMerits.rejectionReason', '') &&
            jomStatus === PROCEDURE_STATUSES.REJECTED &&
            !isValidated && (
              <span style={{ marginLeft: '10px', color: COLORS.RED }}>
                {translate(messages.rejectedTitle, props)}
                {` : ${get(
                  judgementOnMerits,
                  'judgementOnMerits.rejectionReason',
                )}`}
              </span>
            )}
          {isExpertReportNotValidated && (
            <span style={{ marginLeft: '10px', color: COLORS.RED }}>
              {translate(messages.expertReportNotValidated, props)}
            </span>
          )}
          {(!isEmpty(
            difference(
              uniq(getVictimIds(props.judgementAddDocuments)),
              get(expertiseReport, 'victimExpertises', []).map(
                (el: any) => el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              ),
            ),
          ) ||
            !isEmpty(
              difference(
                uniq(getVehiculeIds(props.judgementAddDocuments)),
                get(expertiseReport, 'vehiculeExpertises', []).map(
                  (el: any) => el[VEHICULE_EXPERTISE_FIELDS.VEHICULE_ID],
                ),
              ),
            )) &&
            get(judgementOnMerits, 'judgementOnMerits.status') ===
              'PENDING' && (
              <span style={{ marginLeft: '10px', color: COLORS.RED }}>
                {translate(messages.expertReportNotExist, props)}
              </span>
            )}
        </div>
        {!isContested(judgementOnMerits) && !isEmpty(judgementOnMerits) && (
          <JudgementOnMeritsForm
            judgementOnMeritsInfoForm={judgementOnMeritsInfoForm}
            setJudgementOnMeritsInfoForm={setJudgementOnMeritsInfoForm}
            judgementOnMerits={judgementOnMerits}
          />
        )}
        {isContested(judgementOnMerits) && !isEmpty(judgementOnMerits) && (
          <JudgementOnMeritsInfo
            judgementOnMeritsInfo={judgementOnMeritsInfo}
            setJudgementOnMeritsInfo={setJudgementOnMeritsInfo}
            judgementOnMerits={judgementOnMerits}
            judgementAddDocuments={props.judgementAddDocuments}
          />
        )}
        {!isEmpty(judgementOnMerits) &&
          get(
            judgementOnMerits['judgementOnMerits']['jom']['cj'],
            'suedPartys',
          ) && (
            <>
              <div className="judgement-on-merits-title">
                {translate(messages.correctionalJudgementTitle, props)}
              </div>
              <div className="correctional-judgement">
                <div>
                  {!isContested(judgementOnMerits) &&
                    !isEmpty(judgementOnMerits) &&
                    get(
                      judgementOnMerits['judgementOnMerits']['jom']['cj'],
                      'suedPartys',
                    ) &&
                    get(
                      judgementOnMerits['judgementOnMerits']['jom']['cj'],
                      'suedPartys',
                    ).map((el: ISuedPartyType, index: number) => (
                      <>
                        <FormContainer>
                          <div className="condamnation-textfield">
                            <TextField
                              label={translate(
                                { ...messages.condamnationFieldTitle },
                                props,
                              )}
                              onChange={handleCorrectionalCondamnationChange(
                                el?.id,
                              )}
                              value={
                                correctionalJudgementOnMeritsForm.find(
                                  (item: any) => item.id === el.id,
                                )
                                  ? correctionalJudgementOnMeritsForm.find(
                                      (item: any) => item.id === el.id,
                                    ).condamnation
                                  : ''
                              }
                            />
                          </div>
                          <FormControl className="input-fields">
                            <InputLabel>
                              {translate(messages.suedPartyTitle, props)}
                            </InputLabel>
                            <Select
                              value={
                                correctionalJudgementOnMeritsForm.find(
                                  (item: any) => item.id === el.id,
                                )
                                  ? correctionalJudgementOnMeritsForm.find(
                                      (item: any) => item.id === el.id,
                                    ).suedPartyId
                                  : ''
                              }
                              onChange={handleCorrectionalSelectChange(el?.id)}
                            >
                              {!isEmpty(get(listings, 'suedParty', [])) &&
                                listings.suedParty.map(suedParty => (
                                  <MenuItem
                                    value={suedParty.id}
                                    key={suedParty.id}
                                  >
                                    {suedParty.title}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </FormContainer>
                      </>
                    ))}
                  {isContested(judgementOnMerits) &&
                    !isEmpty(judgementOnMerits) &&
                    judgementOnMerits['judgementOnMerits']['jom'][
                      'cj'
                    ].suedPartys.map((el: ISuedPartyType, index: number) => (
                      <>
                        <FormContainer>
                          <div className="condamnation-textfield">
                            <TextField
                              label={translate(
                                { ...messages.condamnationFieldTitle },
                                props,
                              )}
                              defaultValue={el.condamnation}
                              InputProps={{ readOnly: true }}
                            />
                          </div>
                          <FormControl className="input-fields">
                            <InputLabel>
                              {translate(messages.suedPartyTitle, props)}
                            </InputLabel>
                            <Select value={el.suedPartyId} disabled={true}>
                              {!isEmpty(get(listings, 'suedParty', [])) &&
                                listings.suedParty.map(suedParty => (
                                  <MenuItem
                                    value={suedParty.id}
                                    key={suedParty.id}
                                  >
                                    {suedParty.title}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </FormContainer>
                      </>
                    ))}
                </div>
                <CorrectionalJudgementManagerRecap
                  listings={listings}
                  judgementOnMerits={judgementOnMerits}
                  correctionalContestationReasons={
                    correctionalContestationReasons
                  }
                  setCorrectionalContestationReasons={
                    setCorrectionalContestationReasons
                  }
                  isContested={isContested(judgementOnMerits)}
                  isConsultation={props.isConsultation}
                />
              </div>
            </>
          )}
        {!isEmpty(judgementOnMerits) && getCivilJudgement(judgementOnMerits) && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.sharedResponsability, props)}
            </div>
            <div className="shared-responsability">
              <TextField
                name={'sharedResponsability'}
                data-testId="shared-responsability"
                label={translate(messages.sharedResponsability, props)}
                value={sharedResponsability}
                onChange={handleChangeSharedResponsability}
                className="shared-responsability-field"
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      {translate(
                        { ...messages.responsibiltySharePercentage },
                        props,
                      )}
                    </InputAdornment>
                  ),
                }}
                type="number"
                error={disableSharedResponsibility(
                  sharedResponsability,
                  beneficiaries,
                  get(judgementOnMeritsRequest, 'civjs', []),
                )}
                helperText={
                  disableSharedResponsibility(
                    sharedResponsability,
                    beneficiaries,
                    get(judgementOnMeritsRequest, 'civjs', []),
                  ) && translate(messages.validateRequiredField, props)
                }
              />
            </div>
          </>
        )}
        {!isEmpty(civilJudgementVictims) && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.injuredVictim, props)}
            </div>
            <div className="judgement-add-doc">
              {civjvmRequest
                .filter((item: any) => !item.expertiseJudgementAddDocumentId)
                .map((civjvm: any) => {
                  return (
                    <InjuredVictimsRecap
                      listings={listings}
                      judgementOnMeritsRequest={judgementOnMeritsRequest}
                      isManager={
                        !props.isConsultation &&
                        userPrivileges.userHasPrivilege(
                          PRIVILEGES.ISCOURTMANAGER,
                        )
                      }
                      modeType={MODE_TYPES.RECAP}
                      judgement={judgement}
                      setJudgement={setJudgement}
                      judgementForNonCompensation={
                        JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION
                      }
                      civjvms={civjvmRequest.filter(
                        (item: any) => !item.expertiseJudgementAddDocumentId,
                      )}
                      civjWithNonCompensation={civjvm}
                      handleCivJvmChange={handleCivJvmChange}
                      judgementOnMerits={judgementOnMerits}
                      sagisVictimInfo={props.sagisVictimInfo}
                      victim={{
                        id: get(civjvm, 'victimId'),
                        ...get(civjvm, 'victim', {}),
                      }}
                      expertiseJudgementAddDocumentId={get(
                        civjvm,
                        'expertiseJudgementAddDocumentId',
                      )}
                      civj={{}}
                      setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                      civjvmRequest={civjvmRequest}
                      setCivjvmRequest={setCivjvmRequest}
                      setCivilJudgements={setCivilJudgements}
                      civilJudgements={civilJudgements}
                      isDisabled={false}
                      dahirAmount={dahirAmountByVictimKey}
                    />
                  );
                })}
            </div>
          </>
        )}
        {!isDeceasedVictimsOnly(victims) && !props.isConsultation && (
          <CivilJudgementForm
            judgementOnMeritsRequest={judgementOnMeritsRequest}
            setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
            dahirAmount={dahirAmountByVictimKey}
            judgementOnMerits={judgementOnMerits}
            judgementAddDocuments={props.judgementAddDocuments}
            isDisabled={isCJDisabled}
            setIsDisabled={setIsCJDisabled}
            judgementAddAppeal={props.judgementAddAppeal}
            allJudgementDocuments={allJudgementAddDocuments}
            isAppeal={false}
            sharedResponsability={sharedResponsability}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            victims={victims}
            injuredVictims={getInjuredVictims(
              getJudgementAddDocuments(
                props.judgementAddDocuments,
                [],
                judgementOnMerits,
              ),
              victims,
            )}
            isMultiple={props.isMultiple}
            listings={listings}
            setJudgement={setJudgement}
            judgement={judgement}
            expertiseReport={expertiseReport}
          />
        )}
        {!isEmpty(judgementOnMerits) &&
          filterAccountingCivjs(
            civilJudgements,
            civjvmRequest,
            get(judgementOnMeritsRequest, 'civjVehicle', []),
            props.judgementAddDocuments,
          ).map((civilJudgement: ICivilJudgement, index: number) => (
            <>
              <div className="judgement-add-doc-title">
                {translate(messages.judgementCivilRecap, props, {
                  index: index + 1,
                  date: props.intl.formatDate(civilJudgement.createdAt, {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }),
                })}
              </div>
              <div key={civilJudgement.id} className="judgement-add-doc">
                <CivilJudgementRecap
                  contestationReasons={contestationReasons}
                  setContestationReasons={setContestationReasons}
                  listings={listings}
                  civilJudgement={civilJudgement}
                  civilJudgements={civilJudgements}
                  setCivilJudgements={setCivilJudgements}
                  isManager={
                    !props.isConsultation &&
                    userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)
                  }
                  isContested={isContested(judgementOnMerits)}
                  dahirAmount={
                    dahirAmountByVictimKey as { [key: string]: number }
                  }
                  responsabilityShareValue={
                    civilJudgementOnMeritsForm.find(
                      (item: any) => item.id === civilJudgement.id,
                    )
                      ? civilJudgementOnMeritsForm.find(
                          (item: any) => item.id === civilJudgement.id,
                        ).responsibilityShare
                      : ''
                  }
                  handleCivilResponsabilityShareChange={handleCivilResponsabilityShareChange(
                    civilJudgement.id,
                  )}
                  medicalExpertise={civilJudgementOnMeritsFormMedicalExpertise.find(
                    (item: any) => item.id === civilJudgement.id,
                  )}
                  handleMedExpertiseChange={handleMedExpertiseChange(
                    civilJudgement.id,
                  )}
                  accountingExpertise={civilJudgementOnMeritsFormAccountingExpertise.find(
                    (item: any) => item.id === civilJudgement.id,
                  )}
                  handleAccExpertiseChange={handleAccExpertiseChange(
                    civilJudgement.id,
                  )}
                  civilJudgementMechanicalExpertise={civilJudgementOnMeritsFormMechanicalExpertise.find(
                    (item: any) => item.id === civilJudgement.id,
                  )}
                  handleMechanicalExpertiseChange={handleMechanicalExpertiseChange(
                    civilJudgement.id,
                  )}
                  sagisVictimInfo={props.sagisVictimInfo}
                  sagisOpposingParties={props.sagisOpposingParties}
                  judgementOnMeritsRequest={judgementOnMeritsRequest}
                  setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                  judgement={judgement}
                  setJudgement={setJudgement}
                  civjvmRequest={civjvmRequest}
                  handleCivJvmChange={handleCivJvmChange}
                  handleCivjVehicleChange={handleCivjVehicleChange}
                  judgementOnMerits={judgementOnMerits}
                  civilJudgementOnMeritsFormAccountingExpertise={
                    civilJudgementOnMeritsFormAccountingExpertise
                  }
                  setCivilJudgementOnMeritsFormAccountingExpertise={
                    setCivilJudgementOnMeritsFormAccountingExpertise
                  }
                  civilJudgementOnMeritsFormMedicalExpertise={
                    civilJudgementOnMeritsFormMedicalExpertise
                  }
                  setCivilJudgementOnMeritsFormMedicalExpertise={
                    setCivilJudgementOnMeritsFormMedicalExpertise
                  }
                  setCivjvmRequest={setCivjvmRequest}
                  civilJudgementOnMeritsFormMechanicalExpertise={
                    civilJudgementOnMeritsFormMechanicalExpertise
                  }
                  setCivilJudgementOnMeritsFormMechanicalExpertise={
                    setCivilJudgementOnMeritsFormMechanicalExpertise
                  }
                  judgementAddDocument={getJudgementAddDocument(
                    civilJudgement,
                    props.judgementAddDocuments,
                    get(expertiseReport, 'victimExpertises', []),
                    get(expertiseReport, 'vehiculeExpertises', []),
                  )}
                  judgementAddDocuments={formatExpertisesWithExpertReport(
                    props.judgementAddDocuments,
                    get(expertiseReport, 'victimExpertises', []),
                    get(expertiseReport, 'vehiculeExpertises', []),
                  )}
                  expertiseReport={expertiseReport}
                />
              </div>
            </>
          ))}

        {(!isEmpty(
          getBeneficiaries(
            props.judgementAddClone,
            get(judgementOnMerits, 'judgementOnMerits.jom.id'),
          ),
        ) ||
          !isEmpty(deceasedVictimInJom)) && (
          <DeceasedVictim
            isRecap={true}
            isManager={
              !props.isConsultation &&
              userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)
            }
            beneficiairies={beneficiaries}
            judgementAdd={props.judgementAddClone}
            listing={listings}
            handleChangeDesceasedVictim={handleChangeDesceasedVictim}
            handleChangeBeneficiaries={setBeneficiaries}
            judgementOnMerits={judgementOnMerits}
            RecapInfo={judgementOnMerits['beneficiaries']}
            beneficiaryContestationReasons={beneficiaryContestationReasons}
            setBeneficiaryContestationReasons={
              setBeneficiaryContestationReasons
            }
            isContested={isContested(judgementOnMerits)}
            dahirAmount={dahirAmountByVictimKey}
            currentJudiciaryProcess={currentJudiciaryProcess}
            desceasedVictims={deceasedVictim}
            victims={victims}
            allVictims={getVictims()}
            associatedVictims={props.jomAssociatedVictims}
            jomDeceasedVictims={props.jomDeceasedVictims}
            isMultiple={props.isMultiple}
            sharedResponsability={sharedResponsability as any}
            setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
            judgementOnMeritsRequest={judgementOnMeritsRequest}
            dahirAmountByVictimKey={dahirAmountByVictimKey}
            lossDate={get(claimRecap, 'claim.lossDate')}
          />
        )}
        <div className="judgement-on-merits-title">
          {translate(messages.judgementOnMeritsAdditionalInfo, props)}
        </div>
        {!isContested(judgementOnMerits) && !isEmpty(judgementOnMerits) && (
          <AdditionalInfoJudgementOnMeritForm
            additionalJudgementOnMeritsInfoForm={
              additionalJudgementOnMeritsInfoForm
            }
            judgementOnMeritsFormDocument={judgementOnMeritsFormDocument}
            setJudgementOnMeritsFormDocument={setJudgementOnMeritsFormDocument}
            setAdditionalJudgementOnMeritsInfoForm={
              setAdditionalJudgementOnMeritsInfoForm
            }
            judgementOnMerits={judgementOnMerits}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            handleJudgementOnMeritsDocChange={() => {}}
            uploadedDocument={uploadedDocument}
            setDocumentId={setDocumentId}
            documentId={documentId}
            requestAddJudgementOnMeritsSupportDocument={
              props.requestAddJudgementOnMeritsSupportDocument
            }
            claimId={claimId}
            claimNumber={claimNumber}
            isCivilProceeding={props.isCivilProceeding}
            isManager={!props.isConsultation}
            isAssignedLawyer={props.isAssignedLawyer}
            isCreator={props.isAssignedLawyer}
            requestMakeDecisionSupportDocument={
              props.requestMakeDecisionSupportDocument
            }
            judiciaryProcessId={get(
              judgementOnMerits['judgementOnMerits'],
              'judiciaryProcessId',
            )}
            claim={claim}
            imagineDocuments={props.imagineDocuments}
            policyInfo={policyInfo}
            listings={listings}
            isConsultation={props.isConsultation}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
        {isContested(judgementOnMerits) && !isEmpty(judgementOnMerits) && (
          <AdditionalInfoJudgementOnMerit
            judgementOnMeritsInfo={judgementOnMeritsInfo}
            setJudgementOnMeritsInfo={setJudgementOnMeritsInfo}
            judgementOnMerits={judgementOnMerits}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            handleJudgementOnMeritsDocChange={() => {}}
            uploadedDocument={uploadedDocument}
            setDocumentId={setDocumentId}
            documentId={documentId}
            isAssignedLawyer={props.isAssignedLawyer}
            requestAddJudgementOnMeritsSupportDocument={
              props.requestAddJudgementOnMeritsSupportDocument
            }
            requestMakeDecisionSupportDocument={
              props.requestMakeDecisionSupportDocument
            }
            claim={claim}
            judiciaryProcessId={get(
              judgementOnMerits['judgementOnMerits'],
              'judiciaryProcessId',
            )}
            imagineDocuments={props.imagineDocuments}
            policyInfo={policyInfo}
            listings={listings}
            isConsultation={props.isConsultation}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
        <>
          {userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
            !props.isConsultation && (
              <div>
                <section className="submit-form">
                  <SecondaryButton
                    title={translate(messages.goBackButton, props)}
                    data-testid="go-back"
                  />
                  <DropDownDecisionMenu
                    setDropDown={setDropDown}
                    dropDown={dropDown}
                    height={'46'}
                    label={translate(messages.managerDecisionTitle, props)}
                    menuElements={resolveDropDownMenuElements() as any}
                  />
                </section>
                {featureService.hasFeature(
                  FEATURES.JUDGEMENT_ON_MERITS_CONTESTATION,
                ) ? (
                  <div>
                    <SahamDrawer
                      open={isContestationDrawerOpen}
                      handleToggleDrawer={() =>
                        setIsContestationDrawerOpen(false)
                      }
                      title={translate(messages.contestationDrawerTitle, props)}
                      confirmButtonTitle={translate(
                        messages.validateButton,
                        props,
                      )}
                      isDisplayCancelButton
                      isDisplayCloseButton
                      handleValidateDrawer={handleValidateJudgementOnMerits(
                        true,
                        false,
                      )}
                    >
                      <FormContainer>
                        <FormControl className="formEl">
                          <InputLabel>
                            {translate(
                              messages.judgementOnMeritsContestationType,
                              props,
                            )}
                          </InputLabel>
                          <Select
                            onChange={handleFormChange(CONTESTATION.TYPE)}
                            name={CONTESTATION.TYPE}
                            data-testid={CONTESTATION.TYPE}
                            id={CONTESTATION.TYPE}
                            value={get(
                              formContestationValues,
                              [CONTESTATION.TYPE],
                              '',
                            )}
                          >
                            {get(
                              listings,
                              'judgementOnMeritsContestationTypes',
                              [],
                            )
                              .filter(
                                (el: any) =>
                                  (el.displayedFor ===
                                    PROCEDURE_TYPES.FIRST_INSTANCE ||
                                    isNil(el.displayedFor)) &&
                                  el.isVisible,
                              )
                              .map((type: Config) => (
                                <MenuItem value={type.id} key={type.id}>
                                  {type.title}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </FormContainer>
                      {formContestationValues[CONTESTATION.TYPE] === 2 && (
                        <FormContainer>
                          <FormControl className="formEl">
                            <InputLabel>
                              {translate(
                                messages.judgementOnMeritsContestationWithdrawalReason,
                                props,
                              )}
                            </InputLabel>
                            <Select
                              onChange={handleFormChange(
                                CONTESTATION.WITHDRAWALREASON,
                              )}
                              name={CONTESTATION.WITHDRAWALREASON}
                              value={get(
                                formContestationValues,
                                [CONTESTATION.WITHDRAWALREASON],
                                '',
                              )}
                            >
                              {get(
                                listings,
                                'judgementOnMeritsContestationWithdrawalReasons',
                                [],
                              ).map((type: Config) => (
                                <MenuItem value={type.id} key={type.id}>
                                  {type.title}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </FormContainer>
                      )}
                      <FormContainer>
                        <FormControl className="formEl">
                          <InputLabel>
                            {translate(
                              messages.judgementOnMeritsContestationOwner,
                              props,
                            )}
                          </InputLabel>
                          <Select
                            onChange={handleFormChange(CONTESTATION.OWNER)}
                            name={CONTESTATION.OWNER}
                            value={get(
                              formContestationValues,
                              [CONTESTATION.OWNER],
                              '',
                            )}
                          >
                            {get(
                              listings,
                              'judgementOnMeritsContestationOwners',
                              [],
                            ).map((type: Config) => (
                              <MenuItem value={type.id} key={type.id}>
                                {type.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </FormContainer>
                      <FormContainer>
                        <FormControl className="formEl">
                          <InputLabel>
                            {translate(
                              messages.judgementOnMeritsContestationAgainst,
                              props,
                            )}
                          </InputLabel>
                          <Select
                            onChange={handleFormChange(CONTESTATION.AGAINST)}
                            name={CONTESTATION.AGAINST}
                            data-testid={CONTESTATION.AGAINST}
                            value={get(
                              formContestationValues,
                              [CONTESTATION.AGAINST],
                              '',
                            )}
                          >
                            <MenuItem
                              value={CONTESTATION_AGAINST.VICTIM}
                              key={0}
                            >
                              {CONTESTATION_AGAINST.VICTIM}
                            </MenuItem>
                            <MenuItem
                              value={CONTESTATION_AGAINST.VEHICLE}
                              key={1}
                            >
                              {CONTESTATION_AGAINST.VEHICLE}
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </FormContainer>
                      {formContestationValues[CONTESTATION.AGAINST] ===
                        CONTESTATION_AGAINST.VICTIM && (
                        <FormContainer>
                          <FormGroup>
                            {victims.map((victim: VictimType) => (
                              <div>
                                <FormControlLabel
                                  key={victim.id}
                                  control={
                                    <Checkbox
                                      data-testid="checkboxId"
                                      checked={IsVictimChecked(
                                        victim.id as any,
                                        selectedVictims,
                                      )}
                                      color="primary"
                                      onChange={handleVictimChangeCheckBox(
                                        victim.id as any,
                                      )}
                                    />
                                  }
                                  label={
                                    featureService.hasFeature(
                                      FEATURES.MIGRATION_CLAIM_INFO,
                                    )
                                      ? `${get(
                                          getVictimFromSagisInfo(
                                            get(victim, 'victimKey'),
                                            props.sagisVictimInfo,
                                          ),
                                          'victimFirstName',
                                          '',
                                        )} ${get(
                                          getVictimFromSagisInfo(
                                            get(victim, 'victimKey'),
                                            props.sagisVictimInfo,
                                          ),
                                          'victimLastName',
                                          '',
                                        )}`
                                      : getVictimFullName(victim)
                                  }
                                />

                                {IsVictimChecked(
                                  victim.id as any,
                                  selectedVictims,
                                ) &&
                                  get(victim, 'beneficiaries', []).map(
                                    (beneficiary: any) => (
                                      <div style={{ marginLeft: '20px' }}>
                                        <div className="info-item">
                                          {translate(
                                            {
                                              ...messages.judgementOnMeritsContestationBeneficiaries,
                                            },
                                            props,
                                          )}
                                        </div>

                                        <FormControlLabel
                                          key={beneficiary.id}
                                          control={
                                            <Checkbox
                                              name="beneficiary"
                                              checked={isBeneficiaryChecked(
                                                beneficiary.id,
                                              )}
                                              color="primary"
                                              onChange={handleBeneficiaryCheckBox(
                                                victim.id as any,
                                                beneficiary.id,
                                                (victim.beneficiaries as unknown) as any,
                                              )}
                                            />
                                          }
                                          label={`${beneficiary.firstName} ${beneficiary.lastName}`}
                                        />
                                      </div>
                                    ),
                                  )}
                              </div>
                            ))}
                          </FormGroup>
                        </FormContainer>
                      )}
                      {formContestationValues[CONTESTATION.AGAINST] ===
                        CONTESTATION_AGAINST.VEHICLE && (
                        <FormContainer>
                          <FormGroup>
                            {vehicules.map((vehicule: any, index: number) => (
                              <FormControlLabel
                                key={index}
                                control={
                                  <Checkbox
                                    data-testid="checkboxId"
                                    checked={IsVehicleChecked(
                                      vehicule.id,
                                      selectedVehicles,
                                    )}
                                    color="primary"
                                    onChange={handleVehicleChangeCheckBox(
                                      vehicule.id,
                                    )}
                                  />
                                }
                                label={vehicule.registrationNumber}
                              />
                            ))}
                          </FormGroup>
                        </FormContainer>
                      )}
                      <FormContainer>
                        <FormControl className="formEl">
                          <TextField
                            label={translate(
                              {
                                ...messages.judgementOnMeritsContestationCommentary,
                              },
                              props,
                            )}
                            className="formEl"
                            onChange={handleFormChange(CONTESTATION.COMMENTARY)}
                            name={CONTESTATION.COMMENTARY}
                            value={get(formContestationValues, [
                              CONTESTATION.COMMENTARY,
                            ])}
                          />
                        </FormControl>
                      </FormContainer>
                      <FormContainer>
                        <FormControl className="formEl">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={IsDifficultyExecutionChecked}
                                color="primary"
                                onChange={handleDifficultyExecutionCheckBox}
                              />
                            }
                            label={translate(
                              messages.judgementOnMeritsContestationDifficultyExecution,
                              props,
                            )}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isDefenseExecutionChecked}
                                color="primary"
                                onChange={handleDefenseExecutionCheckBox}
                              />
                            }
                            label={translate(
                              messages.judgementOnMeritsContestationDefenseExecution,
                              props,
                            )}
                          />
                        </FormControl>
                      </FormContainer>
                    </SahamDrawer>
                  </div>
                ) : (
                  !props.isConsultation && (
                    <PrimaryButton
                      data-testid="validate"
                      background={BUTTON_COLORS.PRIMARY_BLUE}
                      border={BUTTON_COLORS.PRIMARY_BLUE}
                      titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                      title={translate(messages.validateButton, props)}
                      onClick={handleValidateJudgementOnMerits(true, false)}
                    />
                  )
                )}
              </div>
            )}
        </>
      </div>
      <RejectionDialog
        isRejectionDialogOpen={isRejectionDialogOpen}
        setIsRejectionDialogOpen={setIsRejectionDialogOpen}
        requestValidateJudgementOnMerits={requestValidateJudgementOnMerits}
        lawyer={getValueByCode(
          get(claim, 'assignment.assignedLawyer', ''),
          get(listings, 'intervenants', []),
        )}
        claimId={claimId}
        claimNumber={claimNumber}
        judiciaryProcessId={get(
          judgementOnMerits['judgementOnMerits'],
          'judiciaryProcessId',
        )}
        judgementDate={moment(
          get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate'),
        ).format('DD/MM/YYYY')}
        judgementId={get(judgementOnMerits['judgementOnMerits'], 'id')}
        jomId={get(judgementOnMerits, 'judgementOnMerits.jom.id')}
        setJomStatus={setJomStatus}
        isMultiple={props.isMultiple}
        setIsButtonRedirect={props.setIsButtonRedirect}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      {featureService.hasFeature(FEATURES.ADD_MULTIPLE_JOM) && (
        <AddJomDrawer
          open={isAddJomDrawerOpen}
          victims={
            isPendingApprovalClaim(claimRecap) ? victims : filterVictim(victims)
          }
          handleToggleDrawer={handleToggleAddJomDrawer}
          handleSubmit={() => handleSubmitCreateJom()}
          associatedVictims={associatedVictims}
          setAssociatedVictims={setAssociatedVictims}
          vehicles={vehicules}
          associatedVehicles={associatedVehicles}
          setAssociatedVehicles={setAssociatedVehicles}
          civilVictimsToInclude={civilVictimsToInclude}
          jomVictimsToInclude={jomVictimsToInclude}
          civilVehiclesToInclude={civilVehiclesToInclude}
          jomVehiclesToInclude={jomVehiclesToInclude}
          isCivilJudiciaryProcess={props.isCivilProceeding}
          jomDeceasedVictims={props.jomDeceasedVictims}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
        />
      )}
      {openDialogValidation &&
        featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) && (
          <ValidationDialog
            open={openDialogValidation}
            handleClose={() => setOpenDialogValidation(false)}
            handleValidate={handleValidateJudgementOnMerits(false, false)}
          />
        )}
      {isAppealDialogOpen && (
        <Dialog
          open={isAppealDialogOpen}
          handleClose={handleCloseAppealDialog}
          handleValidate={handleValidateAppealDialog}
          title={translate(messages.JudgementAppealTabTitle, props)}
          confirmTitle={translate(messages.confirm, props)}
          cancelTitle={translate(messages.cancel, props)}
        >
          <div className="content">
            {translate(messages.appealMultiple, props)}
          </div>
        </Dialog>
      )}
      {openDialog && (
        <Dialog
          open={openDialog}
          handleClose={handleCloseDialog}
          handleValidate={handleValidateArchiveJudgement}
          title={translate(messages.archiveJudgementTitle, props)}
          confirmTitle={translate(messages.confirm, props)}
          cancelTitle={translate(messages.cancel, props)}
          validateButtonDisabled={
            isEmpty(archiveReason) || isNil(archiveReason)
          }
        >
          <div className="content">
            {translate(messages.archiveJudgementSubTitle, props)}
          </div>
          <TextField
            name="ArchiveReason"
            fullWidth
            value={archiveReason}
            onChange={handleChange}
            error={isEmpty(archiveReason)}
            helperText={
              isEmpty(archiveReason) &&
              translate(messages.archiveReasonFieldError, props)
            }
            multiline
          />
        </Dialog>
      )}
    </Container>
  );
};

export default injectIntl(JudgementOnMeritsManagerRecap);
